// extracted by mini-css-extract-plugin
module.exports = {"snackbarRoot":"App_snackbarRoot__LFDlI","snackbar":"App_snackbar__1CQR9"};